import { render, staticRenderFns } from "./autotemplate.vue?vue&type=template&id=55f00608&scoped=true&"
import script from "./autotemplate.vue?vue&type=script&lang=js&"
export * from "./autotemplate.vue?vue&type=script&lang=js&"
import style0 from "./autotemplate.vue?vue&type=style&index=0&id=55f00608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f00608",
  null
  
)

export default component.exports